import addEntity from 'owa-controls-findpeople-feedback-manager/lib/actions/addEntity';
import FindControlViewState from '../store/schema/FindControlViewState';
import { FindResultType } from '../store/schema/FindControlViewState';
import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import { isNullOrWhiteSpace } from 'owa-string-utils';

const PRIVATE_DL_ROUTING_TYPE = 'PDL';

/**
 * Adds a find people entity feedback for a persona picked from the find control
 */
export default function addFindPeopleEntityFromResults(
    recipientWellViewState: FindControlViewState,
    persona: FindRecipientPersonaType,
    findResultIndex: number
) {
    if (persona) {
        let displayName = getDisplayName(persona);
        let extraData = {
            TargetEntityType: persona.PersonaTypeString,
            ReferenceId: persona.ReferenceId,
        };

        if (!isNullOrWhiteSpace(displayName)) {
            let recipientEmailAddressesAndPositionIndexesDictionary: {
                [displayName: string]: number;
            } = {};
            recipientEmailAddressesAndPositionIndexesDictionary[displayName] = findResultIndex;

            addEntity(
                recipientWellViewState.findPeopleFeedbackManager,
                getEntityAddSource(recipientWellViewState.findResultType),
                recipientWellViewState.queryString,
                displayName,
                persona.TransactionId,
                recipientEmailAddressesAndPositionIndexesDictionary,
                extraData
            );
        }
    }
}

function getDisplayName(persona: FindRecipientPersonaType): string {
    let email = persona.EmailAddress;
    let isPDL = email.RoutingType === PRIVATE_DL_ROUTING_TYPE;

    return isPDL ? email.Name : email.EmailAddress;
}

function getEntityAddSource(findResultType: FindResultType): EntityAddSource {
    switch (findResultType) {
        case FindResultType.Cache:
            return EntityAddSource.LocalCache;
        case FindResultType.FindPeople:
            return EntityAddSource.EntityRelevanceApi;
        case FindResultType.SearchDirectory:
            return EntityAddSource.ActiveDirectory;
        case FindResultType.MixedCacheLive:
            return EntityAddSource.LocalCacheAndEntityRelevanceApi;
        default:
            return EntityAddSource.Other;
    }
}
